import { render, staticRenderFns } from "./ContentAndImage.vue?vue&type=template&id=c6287dd8&scoped=true&"
import script from "./ContentAndImage.vue?vue&type=script&lang=js&"
export * from "./ContentAndImage.vue?vue&type=script&lang=js&"
import style0 from "./ContentAndImage.vue?vue&type=style&index=0&id=c6287dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6287dd8",
  null
  
)

export default component.exports